document.addEventListener("DOMContentLoaded", function() {
    class CustomCarousel extends window.HTMLElement {
        constructor() {
            super();
            this.selectors = {
                loop: "data-loop",
                scrollCount: "[data-scroll-num]",
                dragFree: "data-drag-free",
                align: "data-align",
                controls: "data-controls",
                autoplay: "data-autoplay",
                autoplayInterval: "data-autoplay-interval",
                carouselContainer: ".carousel-container",
                customAxis: "data-axis",
                dragDisable: "data-drag-disabled"
            };

            this.observer = null;
        }

        connectedCallback() {
            const loop = this.hasAttribute(this.selectors.loop);
            const scrollCount = this.getAttribute(this.selectors.scrollCount) ?? 1;
            const dragFree = this.hasAttribute(this.selectors.dragFree);
            const controls = this.hasAttribute(this.selectors.controls);
            const align = this.getAttribute(this.selectors.align) ?? 'start';
            const autoplay = this.hasAttribute(this.selectors.autoplay);
            const autoplayInterval = parseInt(this.getAttribute(this.selectors.autoplayInterval)) || 5000;
            const slides = this.querySelectorAll(".slide");
            const customAxis = this.getAttribute(this.selectors.customAxis);

            let isDragEnabled = true;
            let axis = 'x';
            if (window.matchMedia("(min-width: 1024px)").matches) {
                axis = 'y';
            }
            
            if (window.matchMedia("(min-width: 1024px)").matches && this.hasAttribute(this.selectors.dragDisable)) {
                isDragEnabled = false;
            }

            const carouselContainer = this.querySelector(this.selectors.carouselContainer);

            const options = {
                loop: loop,
                align: align,
                dragFree: dragFree,
                skipSnaps: false,
                slidesToScroll: parseInt(scrollCount),
                axis: customAxis? customAxis : axis,
                speed: 8, // Increase speed for easing effect
                easing: (t) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2, // Custom ease-in-out function
                watchDrag: isDragEnabled,
            };

            const plugins = [
                (autoplay && slides.length >= 3) ? EmblaCarouselAutoplay({ delay: autoplayInterval, stopOnInteraction: false, stopOnMouseEnter: true }) : null
            ].filter(Boolean);

            this.embla = EmblaCarousel(carouselContainer, options, plugins);

            if (controls) {
                this.setupControls();
            }

            this.setupIntersectionObserver();
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
            if (this.embla) {
                this.embla.destroy();
                this.embla = null;
            }
        }

        setupControls() {
            const prevBtnNodes = Array.from(this.querySelectorAll(".embla__button--prev"));
            const nextBtnNodes = Array.from(this.querySelectorAll(".embla__button--next"));

            prevBtnNodes.forEach((prevBtnNode, index) => {
                const nextBtnNode = nextBtnNodes[index];
                if (nextBtnNode) {
                    const removePrevNextBtnsClickHandlers = this.addPrevNextBtnsClickHandlers(
                        this.embla,
                        prevBtnNode,
                        nextBtnNode
                    );
                    this.embla.on('destroy', removePrevNextBtnsClickHandlers);
                }
            });
        }

        setupIntersectionObserver() {
            const carouselContainer = this.querySelector(this.selectors.carouselContainer);
            const slides = carouselContainer.querySelectorAll('.slide');

            const observerOptions = {
                root: carouselContainer,
                threshold: 0.5
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        gsap.to(entry.target, { autoAlpha: 1, duration: 0.5 });
                    } else {
                        gsap.to(entry.target, { autoAlpha: 0, duration: 0.5 });
                    }
                });
            }, observerOptions);

            slides.forEach(slide => this.observer.observe(slide));
        }

        addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn) {
            const togglePrevNextBtnsState = () => {
                if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
                else prevBtn.setAttribute('disabled', 'disabled');

                if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
                else nextBtn.setAttribute('disabled', 'disabled');
            };

            emblaApi
                .on('select', togglePrevNextBtnsState)
                .on('init', togglePrevNextBtnsState)
                .on('reInit', togglePrevNextBtnsState);

            return () => {
                prevBtn.removeAttribute('disabled');
                nextBtn.removeAttribute('disabled');
            };
        }

        addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
            const scrollPrev = () => {
                emblaApi.scrollPrev();
            };
            const scrollNext = () => {
                emblaApi.scrollNext();
            };
            prevBtn.addEventListener('click', scrollPrev, false);
            nextBtn.addEventListener('click', scrollNext, false);

            const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
                emblaApi,
                prevBtn,
                nextBtn
            );

            return () => {
                removeTogglePrevNextBtnsActive();
                prevBtn.removeEventListener('click', scrollPrev, false);
                nextBtn.removeEventListener('click', scrollNext, false);
            };
        }
    }

    window.customElements.define("custom-carousel", CustomCarousel);
});